<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width=24
    :height=24
    viewBox="0 0 24 24"
    fill="none"
  >
    <g id="IconContact">
      <g id="vuesax/bulk/book-saved">
        <g id="book-saved">
          <path id="Vector" d="M12 5.29971V21.3297C12.17 21.3297 12.35 21.2997 12.49 21.2197L12.53 21.1997C14.45 20.1497 17.8 19.0497 19.97 18.7597L20.26 18.7197C21.22 18.5997 22 17.6997 22 16.7397V4.65969C22 3.46969 21.03 2.5697 19.84 2.6697C17.74 2.8397 14.56 3.89973 12.78 5.00973L12.53 5.15969C12.38 5.24969 12.19 5.29971 12 5.29971Z" fill="#FFC304"/>
          <path id="Vector_2" d="M2 4.66953V16.7395C2 17.6995 2.77999 18.5995 3.73999 18.7195L4.07001 18.7596C6.25001 19.0496 9.61003 20.1595 11.53 21.2195C11.66 21.2995 11.82 21.3296 12 21.3296V5.29954C11.81 5.29954 11.62 5.24952 11.47 5.15952L11.3 5.04954C9.51999 3.92954 6.32998 2.85954 4.22998 2.67954H4.16998C2.97998 2.57954 2 3.46953 2 4.66953Z" fill="#D5D8DC"/>
          <path id="Vector_3" d="M19 2.7793V7.06927C19 7.46927 18.56 7.70926 18.22 7.48926L17 6.67926L15.78 7.48926C15.45 7.70926 15 7.46927 15 7.06927V3.91925C16.31 3.39925 17.77 2.9793 19 2.7793Z" fill="#3CB149"/>
        </g>
      </g>
    </g>
  </svg>

</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
